export const ebayReviews = [
    {
      "buyerName": "s***a",
      "comment": "Amazing !! My daughter is going to be made up on her birthday. Fantastic communication throughout. So much care was taken when packaging this up to send to ensure the box didn’t get damaged and it arrived in perfect condition. Thank you so much. Brilliant value. The quality is perfect.",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "t***t",
      "comment": "Fast & smooth transaction. Item arrived just as described. Well packaged. Would buy from again.",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "n***f",
      "comment": "As described, good communication and prompt delivery. Great deal and would recommend the seller.",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "f***3",
      "comment": "Definitely! Here's a review you can use: I received my package on time, and it was Professionally wrapped. The card was a great touch, and the product is working perfectly. Overall, it was an excellent deserving an A rating. Thank you! I will be recommending this seller to my friends and family with out a shadow of a doubt 👍",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "1***l",
      "comment": "Amazing seller, package came quickly and a very nice and genuine guy, one or the best sellers I've come across on this app; would recommend.",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "n***r",
      "comment": "Absolutely love this. It’s a good price for a quality product and dispatch was quick and efficient. I received it well packaged and will definitely buy again. Thank you",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "m***m",
      "comment": "Got Exactly as was stated!",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "a***n",
      "comment": "Fast delivery as described. *****",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "n***u",
      "comment": "Excellent ebayer. Very fast postage and in great condition. Thank you - recommended",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "m***i",
      "comment": "Arrived super quickly, and well packaged! Thank you!",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "l***l",
      "comment": "Gorgeous item, fast delivery. Item as described",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "s***g",
      "comment": "Thank you so much! Genuine item, super fast delivery, Highly recommended seller",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "i***-",
      "comment": "Thank you arrived before stated date",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "c***o",
      "comment": "As described",
      "leftBefore": "Past month",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "n***1",
      "comment": "Lovely as described",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "e***n",
      "comment": "Quality product Quality ebayer",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "8***5",
      "comment": "Excellent ebayer many thanks",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "l***9",
      "comment": "Good seller highly recommend",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "a***n",
      "comment": "Fabulous perfume and 100% genuine , buy with confidence. 5 stars 🌟",
      "leftBefore": "Past month",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "a***p",
      "comment": "5*",
      "leftBefore": "Past month",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "3***_",
      "comment": "Lovely experience!",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "****c",
      "comment": "Perfect Thank you 🙂",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "h***9",
      "comment": "Thank you!",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "a***a",
      "comment": "Beautiful 😍",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "p***e",
      "comment": "All good 👍",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "s***l",
      "comment": "Looks cool and brand new",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "a***7",
      "comment": "Bought for a Christmas present for my grandson",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "2***b",
      "comment": "perfect",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "",
      "comment": "This seller successfully completed an order.",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "",
      "comment": "This seller successfully completed an order.",
      "leftBefore": "Past 6 months",
      "type": "ebay",
      "rating": "POSITIVE"
    },
    {
      "buyerName": "",
      "comment": "This seller successfully completed an order.",
      "leftBefore": "Past year",
      "type": "ebay",
      "rating": "POSITIVE"
    }
  ]